import React from "react";
import { Link, useParams } from "react-router-dom";
import Seo from "../components/Seo";
import NoteBody from "../components/NoteBody";
import { SectionLabel, Arrow } from "../components/Section";
import { RESEARCH_NOTES, findNote } from "../config/research";
import NotFound from "./NotFound";

export default function ResearchNote() {
  const { slug } = useParams();
  const note = findNote(slug);
  if (!note) return <NotFound />;
  const index = RESEARCH_NOTES.indexOf(note) + 1;

  return (
    <>
      <Seo title={`${note.title} — Syni.ai Research`} description={note.summary} path={`/research/${note.slug}`} />
      <section className="hero hero--page" data-testid="note-hero">
        <div className="container-syni">
          <div className="note-back">
            <Link to="/research" className="link-arrow" data-testid="note-back-link">
              <Arrow /> Research
            </Link>
          </div>
          <SectionLabel>
            Note {index} · Syni.ai research · {note.year}
          </SectionLabel>
          <h1 className="h-page hero-headline" style={{ marginTop: 24, maxWidth: "20ch" }} data-testid="note-title">
            {note.title}
          </h1>
          <p className="lead note-standfirst measure" data-testid="note-summary">
            {note.summary}
          </p>
        </div>
      </section>

      <section className="section note-section" data-testid="note-article">
        <div className="container-syni">
          <div className="note-article">
            {note.body && note.body.length ? <NoteBody blocks={note.body} /> : null}
            <div className="note-foot">
              <Link to="/research" className="link-arrow" data-testid="note-foot-back-link">
                <Arrow /> All notes
              </Link>
              <Link to="/contact" className="link-arrow" data-testid="note-foot-contact-link">
                <Arrow /> To discuss a research collaboration
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
